import React from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import cn from 'classnames';
import { dateFormats } from '../../../packages/dateTime';
import styles from './index.module.scss';

const DatePicker = ({
  className,
  format = dateFormats.DMY,
  hideCalendarIcon = true,
  ...props
}) => {
  return (
    <AntDatePicker
      {...props}
      className={cn(styles.picker, className, {
        [styles.hideCalendarIcon]: hideCalendarIcon,
      })}
      format={format}
    />
  );
};

export default DatePicker;
